import { loadCldrData } from '~/util/helpers/kendoCldrLoader';
import { getBrowserLocale } from '~/util/helpers/reportsLocale';

export default defineNuxtPlugin(async () => {
  await loadCldrData(getBrowserLocale());
});
